/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';

import { GUIComponent, DynamicContent, DynamicComponent, DynamicObjects, HisGlobalDataService } from 'hisng';

/**
* @deprecated Use moved HisDynamicFormGroupUtils from hisng 
*/ 
@Injectable()
export class DynamicFormGroupUtils {

    private readonly FORMGROUPVALUE = 'dynamicformGroupValue';

    constructor( private globalDataService: HisGlobalDataService ) { }

    /* set dynamic component for object from dynamic container components */
    public setDynamicComponentObject( dynamicContentObject: DynamicContent ) {
        if ( dynamicContentObject._dynamicComponent ) {
            let formGroupValue: Record<string, any> = {};
            let globalDataFormGroupValue = this.globalDataService.getData( this.FORMGROUPVALUE );
            if ( globalDataFormGroupValue ) {
                dynamicContentObject._dynamicComponent.guiComponent.children.forEach( ( tabChild: GUIComponent ) => {
                    tabChild.children.forEach( ( fieldsetChild: GUIComponent ) => {
                        if ( fieldsetChild ) {
                            if ( !formGroupValue[fieldsetChild.name] ) {
                                formGroupValue[fieldsetChild.name] = globalDataFormGroupValue[fieldsetChild.name];
                            } else {
                                Object.assign( formGroupValue[fieldsetChild.name], globalDataFormGroupValue[fieldsetChild.name] );
                            }
                        }
                    } );
                } );
            }
            dynamicContentObject._dynamicComponent = this.convertFormGroupValueToDynamicObjects(
                formGroupValue, dynamicContentObject._dynamicComponent );
        }
    }
    
    public convertFormGroupValueToDynamicObjects(
        formGroupValue: Record<string, any>, dynamicComponentRoot: DynamicComponent ): DynamicComponent {
        // console.log('formGroupValue =', formGroupValue);
        if ( dynamicComponentRoot ) {
            dynamicComponentRoot.guiComponent.children.forEach( ( tabChild: GUIComponent ) => {
                tabChild.children.forEach( ( fieldsetChild: GUIComponent ) => {
                    if ( fieldsetChild ) {
                        this.convertFormValueToDynamicObjectsRecurrent(
                            formGroupValue[fieldsetChild.name], fieldsetChild, dynamicComponentRoot.dynamicObjects );
                    }
                } );
            } );
        }
        return dynamicComponentRoot;
    }
    
    private convertFormValueToDynamicObjectsRecurrent(
        formValue: Record<string, any>, guiComponent: GUIComponent, dynamicObjects: DynamicObjects[] ) {
        if ( formValue ) {
            // console.log('dynamicComponent =', dynamicComponent, ', formValue =', formValue);
            if ( guiComponent.fields ) {
                guiComponent.fields.forEach( ( fieldChild: GUIComponent ) => {
                    // console.log('field', field.name, 'gets value', formValue[field.name]);
                    let dynamicObject = dynamicObjects.find( dO => dO.objGuid === fieldChild.objectUID );
                    if ( dynamicObject ) {
                        let dynamicObjectValue = dynamicObject.values.find( dV => dV.attributeName === fieldChild.attributeName );
                        if ( dynamicObjectValue ) {
                            dynamicObjectValue.value = formValue[fieldChild.name];
                        }
                    }
                } );
            }
            if ( guiComponent.children ) {
                guiComponent.children.forEach( ( fieldChild: GUIComponent ) => {
                    if ( fieldChild ) {
                        this.convertFormValueToDynamicObjectsRecurrent( formValue[fieldChild.name], fieldChild, dynamicObjects );
                    }
                } );
            }
        }
    }


}
